import { Box, FormControl, Grid, MenuItem, OutlinedInput, Select, SelectChangeEvent, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '@/utils/appContext';
import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { makeStyles } from 'tss-react/mui';
import { hunify } from '@/utils/helpers';
import { useResponsive } from '@/hooks/use-responsive';

export const ModalDestinationPickerVP = (props: any) => {

  const appContext = useContext(AppContext);
  const { t } = useTranslation();
  const { classes } = useStyles();

  const handleDestination = (value: string) => {
    if (value === 'all') {
      appContext.searchForms[appContext.orderIndex].property = '';
      appContext.searchForms[appContext.orderIndex].destination = 'all';
    } else {
      appContext.searchForms[appContext.orderIndex].property = value;
      appContext.searchForms[appContext.orderIndex].destination = '';
    }

    appContext.searchForms[appContext.orderIndex].landscape = '';
    appContext.setSearchForms([...appContext.searchForms]);
    props.params.handleCloseModalDestinationPicker();
  };

  const downMd = useResponsive('down', 'md');

  const [where, setWhere] = useState<string>('');
  const handleChangeWhere = (event: SelectChangeEvent) => {
    const {
      target: { value }
    } = event;
    appContext.setUpdateSearch(true);
    setWhere(value);
    handleDestination(value);
  };


  return (
    <Box sx={{ height: '100%', overflow: 'scroll' }}>
      <Grid
        container
        alignItems={'center'}
        justifyContent={'space-evenly'}
        direction={'row'}
        pt={3}
        pb={3}
        pr={3}
        pl={3}
        sx={{ borderBottom: '1px solid #F4F3EF', position: 'relative' }}>
        <Grid item xs={12} textAlign={'center'}>
          <Box display={'flex'} alignItems={'center'} justifyContent={'center'} position={'relative'}
               sx={{ cursor: 'pointer' }}>
            {
              (props.params.container === 'DrawerSearchWidget' || downMd) && (
                <Box position={'absolute'} left={'0'} display={'flex'}>
                  <ArrowBackIcon onClick={() => props.params.handleCloseModalDestinationPicker()} />
                </Box>
              )
            }
            <Typography variant={'h4'} component={'h4'}>
              {t('Destination')}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container direction="row" pr={4} pl={4} pt={3} pb={3} justifyContent="space-between" alignItems="flex-start"
            mb={4}>
        <Grid item width={'100%'} className={classes.tabSelectType}>
          <Grid item xs={12} textAlign={'left'}>
            <Typography variant={'h5'} component={'h5'}>{t('where_want_go')}</Typography>
          </Grid>

          <FormControl sx={{ m: 0 }}>
            <Select
              displayEmpty
              value={where}
              onChange={handleChangeWhere}
              input={<OutlinedInput />}
              MenuProps={{ disablePortal: true }}
              inputProps={{ 'aria-label': 'Without label' }}
              renderValue={() => {
                if (!appContext.searchForms[appContext.orderIndex].property) {
                  return t('select_destinazione_subtitle_vp');
                }
                return appContext.properties.find( property => property.code === appContext.searchForms[appContext.orderIndex].property )?.propertyInfo?.title || ''
                // return t(appContext.searchForms[appContext.orderIndex].property);
              }}>
              {
                (!appContext.cart.length) && (
                  <MenuItem value="all">{t('ovunque_vp')}</MenuItem>
                )
              }
              {appContext.properties.filter( property => appContext.cart.length === 0 || property.property === appContext.cart[0].Property ).map(
                (property, index) =>
                  <MenuItem key={index} value={property.code}>
                    <Typography dangerouslySetInnerHTML={hunify(property.propertyInfo.title)}></Typography>
                  </MenuItem>
              )}
            </Select>
          </FormControl>
          <Grid item width={'100%'}></Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => {
  return {
    tabSelectType: {
      button: {
        fontFamily: theme.typography.body1.fontFamily,
        textTransform: 'initial',
        fontSize: 18
      },
      '.MuiTabs-indicator': {
        backgroundColor: '#000'
      },
      '.MuiTab-root.Mui-selected': {
        color: '#000',
        fontFamily: theme.typography.h1.fontFamily
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#000!important'
      }
    },
    btn: {
      border: '2px solid #000',
      marginTop: '35px',
      button: {
        width: '100%',
        color: 'black',
        textTransform: 'initial',
        alignItems: 'baseline',
        fontSize: 18,
        height: 54,
        minHeight: 54,
        fontFamily: theme.typography.h5.fontFamily,
        maxWidth: '100%'
      },
      svg: {
        position: 'absolute',
        right: 15,
        marginBottom: '0!important'
      }
    },
    overlay: {
      overflow: 'hidden',
      minWidth: 'auto!important',
      img: {
        opacity: '0.7'
      }
    },
    selected: {
      filter: 'brightness(0.1)'
    }
  };
});
